import React from "react";
import IconLightbulb from "venuescanner-js/react/components/Objects/Icons/IconLightbulb";

const EnquirySettingsInfo = ({
  title,
  copy,
  settings,
  setShowSettingsInfo,
}) => {
  return (
    <div className="enquiry-settings-info">
      <div className="enquiry-settings-info__icon">
        <IconLightbulb />
      </div>
      <h3 className="enquiry-settings-info__title">{title}</h3>
      <p className="enquiry-settings-info__copy">{copy}</p>
      <div className="enquiry-settings-info__ctas">
        <a href={settings.pathname}>
          <button className="button button--accept">{settings.copy}</button>
        </a>
        <button
          className="button button--outline-white"
          onClick={setShowSettingsInfo}
        >
          Back to inbox
        </button>
      </div>
    </div>
  );
};

export default EnquirySettingsInfo;
